import LinkExpired from './LinkExpired';

export default LinkExpired;
